module.exports = __webpack_public_path__ + "assets/img/ic-intro-coupon.18fe9f7b.png";